import { render, staticRenderFns } from "./ModalAvaliacao.vue?vue&type=template&id=72f6c87d&"
import script from "./ModalAvaliacao.vue?vue&type=script&lang=js&"
export * from "./ModalAvaliacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalAvaliacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports